module.exports = __webpack_public_path__ + "static/advanced features-integrate-859c77f5d61a545237d75b0c06751e08.png";